import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { any, isEmpty, pluck, values, equals, path, all, length, propOr, prop, compose, filter, identity } from 'ramda';
import {
  Container,
  ExpandIcon,
  OptionBar,
  OptionLabel,
  SubOptions,
  SubOptionsCheckedLabel,
} from './accordionCheckboxOption.styles';
import { WhiteCheckbox } from '../accordionCheckbox.styles';
import { renderWhenTrue } from '../../../utils/rendering';
import { ICON_DOWN } from '../../icon';
import { AccordionCheckboxSubOption } from '../accordionCheckboxSubOption';

export const AccordionCheckboxOption = ({
  inputsState,
  option,
  checkedFieldName,
  subOptionsFieldName,
  labelFieldName,
  onOptionClick,
  onSubOptionClick,
  subOptionsMarkedCountMessage,
  allSubOptionsMarkedMessage,
}) => {
  const [expansion, setExpansion] = useState(false);
  const subOptionsInputValues = values(prop(subOptionsFieldName, inputsState));
  const haveSubOptions = !!compose(
    length,
    values,
    prop(subOptionsFieldName)
  )(option);

  const anySubOptionInputValuesChecked = any(equals(true), pluck('value', subOptionsInputValues));
  const allSubOptionInputValuesChecked = all(equals(true), pluck('value', subOptionsInputValues));
  const allSubOptionInputValuesExists = values(option[subOptionsFieldName]).length === subOptionsInputValues.length;
  const allSubOptionsAreChecked = haveSubOptions && allSubOptionInputValuesExists && allSubOptionInputValuesChecked;
  const selectedSubOptionInputsNumber = filter(equals(true), pluck('value', subOptionsInputValues)).length;

  const handleOnOptionClick = () => {
    if (haveSubOptions) {
      setExpansion(!expansion);
    } else {
      onOptionClick(option[checkedFieldName], option[labelFieldName]);
    }
  };

  return (
    <Container key={option[checkedFieldName]}>
      <OptionBar onClick={handleOnOptionClick} expanded={expansion}>
        <WhiteCheckbox
          withoutPropagation
          name={option[checkedFieldName]}
          value={propOr(false, 'value', inputsState) || anySubOptionInputValuesChecked}
          onChange={() => {
            onOptionClick(option[checkedFieldName], option[labelFieldName]);
          }}
        />
        <OptionLabel>{option[labelFieldName]}</OptionLabel>
        {renderWhenTrue(() => (
          <SubOptionsCheckedLabel>
            <FormattedMessage {...allSubOptionsMarkedMessage} />
          </SubOptionsCheckedLabel>
        ))(allSubOptionsAreChecked)}

        {renderWhenTrue(() => (
          <SubOptionsCheckedLabel>
            <FormattedMessage {...subOptionsMarkedCountMessage} values={{ count: selectedSubOptionInputsNumber }} />
          </SubOptionsCheckedLabel>
        ))(!allSubOptionsAreChecked && Boolean(selectedSubOptionInputsNumber))}

        {renderWhenTrue(() => <ExpandIcon expanded={expansion} name={ICON_DOWN} size={11} />)(
          subOptionsFieldName && !isEmpty(option[subOptionsFieldName])
        )}
      </OptionBar>
      {renderWhenTrue(() => (
        <SubOptions>
          {option[subOptionsFieldName].map(subOption => (
            <AccordionCheckboxSubOption
              key={subOption[checkedFieldName]}
              option={option}
              subOption={subOption}
              labelFieldName={labelFieldName}
              checkedFieldName={checkedFieldName}
              onSubOptionClick={onSubOptionClick}
              inputState={path([subOptionsFieldName, subOption[checkedFieldName]], inputsState)}
            />
          ))}
        </SubOptions>
      ))(expansion)}
    </Container>
  );
};

AccordionCheckboxOption.defaultProps = {
  inputsState: {},
  onSubOptionClick: identity,
};

AccordionCheckboxOption.propTypes = {
  subOptionsMarkedCountMessage: PropTypes.object.isRequired,
  allSubOptionsMarkedMessage: PropTypes.object.isRequired,
  option: PropTypes.object.isRequired,
  checkedFieldName: PropTypes.string.isRequired,
  labelFieldName: PropTypes.string.isRequired,
  inputsState: PropTypes.object,
  subOptionsFieldName: PropTypes.string,
  onOptionClick: PropTypes.func.isRequired,
  onSubOptionClick: PropTypes.func,
};
